export interface ImageSize {
  height: number;
  width: number;
}

export const ImageSizes: Record<string, ImageSize> = {
  generalSettingsBackground: { height: 342, width: 470 },
  mediaFileCard: { height: 150, width: 270 },
  mediaFileUploadCard: { height: 54, width: 100 },
  questionMedia: { height: 235, width: 470 },
  questionPreviewMedia: { height: 100, width: 200 },
  uploadPreviewCompact: { height: 120, width: 165 },
  uploadPreviewRegular: { height: 140, width: 190 },
  uploadPreviewSmall: { height: 50, width: 70 },
};
